<template>
  <v-card
    :class="'base-card quotation-card d-flex ' + textPosition"
    height="160"
    width="240"
    v-on="$listeners"
    v-bind="[$attrs, $props]"
    :style="backgroundImage"
  >
    <v-row>
      <v-spacer />
      <v-col cols="auto" v-if="isTooltip" class="pr-3 pt-5">
        <v-tooltip
          bottom
          content-class="tooltip-label-form-card"
          v-if="tooltipText"
        >
          <template v-slot:activator="{ on }">
            <v-icon color="secondary" size="15" v-on="on">
              fa-info-circle
            </v-icon>
          </template>
          <v-row>
            <v-col cols="12" class="px-4 py-3">
              <p class="white--text tooltip-label-text-card mb-0">
                {{ tooltipText }}
              </p>
            </v-col>
          </v-row>
        </v-tooltip>
      </v-col>
      <v-col v-if="!background" cols="12" class="text-center">
        <NovaEmissao class="quotation-card__svg" v-if="iconDefault" />
        <img :src="nameIcon" class="icon-size-card" v-else />
      </v-col>
      <v-col v-else-if="isIcon" cols="12" class="text-center">
        <img :src="background.url" class="icon-size-card" />
      </v-col>
      <v-col cols="12" :class="paddingCol + ' text-center'">
        <p class="font-weight-bold mb-0 quotation-card__title">
          {{ name }}
        </p>
        <p class="quotation-card__text mb-0" v-if="text">
          {{ text }}
        </p>
        <p class="quotation-card__text mb-0" v-if="value">
          {{ asMoneyString(value) }} *
        </p>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import NovaEmissao from "@/assets/NovaEmissao.vue";
import { asMoneyString } from "@/utils/formats.js";

export default {
  name: "CardDescriptionButton",
  data: () => ({
    asMoneyString
  }),
  components: {
    NovaEmissao
  },
  computed: {
    textPosition() {
      return this.isTooltip ? "align-start" : "align-end";
    },
    paddingCol() {
      return this.text || this.value ? "py-5" : "py-6";
    },
    backgroundImage() {
      return {
        backgroundImage:
          this.background && !this.isIcon
            ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${this.background.url})`
            : "none",
        color:
          this.background && !this.isIcon ? "white" : "var(--v-primary-base)"
      };
    }
  },
  props: {
    name: {
      type: String
    },
    text: {
      type: String,
      default: null
    },
    value: {
      type: Number,
      default: null
    },
    background: {
      type: Object,
      default: null
    },
    isTooltip: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String
    },
    isIcon: {
      type: Boolean,
      default: false
    },
    iconDefault: {
      type: Boolean,
      default: true
    },
    nameIcon: {
      type: String
    }
  }
};
</script>
<style lang="sass">
.v-sheet.v-card:not(.v-sheet--outlined)
  box-shadow: none
.base-card
  border: 1px solid #D5D5E0 !important
  border-radius: 2px !important
  background: #FFF
  cursor: pointer
.base-card:hover, .base-card-active:hover
  opacity: 1 !important
.base-card-active
  border: 1.5px solid #059EE4 !important
  opacity: 1 !important
.quotation-card__title
  line-height: 14px
  font-size: 14px
.quotation-card__text
  font-size: 12px
  line-height: 12px
.quotation-card
  background-size: 100% 100%
  opacity: 0.5
.tooltip-label-form-card
  border-radius: 2px
  background-color: #676778
  box-shadow: 0 7px 10px 0 rgba(44,48,64,0.21)
  max-width: 300px
.tooltip-label-text-card
  font-size: 12
  font-weight: 500
  letter-spacing: 0
  line-height: 16px
  text-align: left
  word-break: break-word
  white-space: pre-wrap
.icon-size-card
  width: 50px
  height: 50px
</style>
